<template>
    <div>
        <div class="attention-line">
            <div v-if="alertLineFlag">
                {{ getDateStringByTimestamp(store.payed_period) }} {{ $t('mainPage.internetBlockAlert') }}
            </div>
        </div>

        <div class="adaptation-block">
            <div class="adaptation-block__column">
                <MyHomeButton :login="store.login" />
                <div @click="$router.push('/profiles-selecting')" class="profile-bar">
                    <div class="profile-bar__address">{{ locale == 'en' ? transliterate(store.address_formatted) : store.address_formatted  }}</div>
                    <div class="profile-bar__login">{{ store.login }}</div>

                    <div class="profile-bar__bar">
                        <svg width="100%" height="200%" viewBox="0 0 323 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.5 7.20711L7.20711 0.5H303.725L322.5 18.2157L322.501 26.815L316.77 33.5H19.2002L0.5 15.7849V7.20711Z" stroke="#CACACA"/>
                            <path d="M322.501 11.8534L310.274 0.5H322.501V11.8534Z" fill="#CACACA" stroke="#CACACA"/>
                            <path d="M0.500977 22.1466L12.7277 33.5H0.500977V22.1466Z" fill="#CACACA" stroke="#CACACA"/>
                            <path d="M301.992 17H301.983" stroke="#E0C522" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M302 23H301.991" stroke="#E0C522" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M301.985 11H301.976" stroke="#E0C522" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M296 10L280 10" stroke="#E0C522" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M296 17L280 17" stroke="#E0C522" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M296 24L280 24" stroke="#E0C522" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M15 0V29.5" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M17 0V31" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M19 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M21 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M23 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M25 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M27 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M29 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M31 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M33 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M35 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M37 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M39 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M41 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M43 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M45 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M47 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M49 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M51 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M53 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M55 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M57 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M59 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M61 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M63 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M65 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M67 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M69 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M71 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M73 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M75 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M77 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M79 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M81 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M83 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M85 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M87 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M89 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M91 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M93 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M95 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M97 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M99 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M101 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M103 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M105 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M107 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M109 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M111 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M113 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M115 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M117 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M119 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M121 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M123 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M125 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M127 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M129 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M131 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M133 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M135 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M137 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M139 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M141 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M143 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M145 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M147 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M149 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M151 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M153 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M155 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M157 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M159 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M161 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M163 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M165 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M167 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M169 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M171 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M173 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M175 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M177 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M179 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M181 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M183 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M185 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M187 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M189 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M191 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M193 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M195 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M197 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M199 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M201 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M203 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M205 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M207 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M209 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M211 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M213 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M215 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M217 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M219 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M221 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M223 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M225 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M227 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M229 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M231 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M233 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M235 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M237 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M239 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M241 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M243 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M245 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M247 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M249 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M251 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M253 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M255 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M257 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M259 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M261 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M263 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M265 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M267 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M269 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M271 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M273 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M275 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M277 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M279 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M281 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M283 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M285 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M287 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M289 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M291 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M293 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M295 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M297 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M299 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M301 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M303 0V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M305 1.49988V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M307 3.50024V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M309 5.50012V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M311 7.34875V34" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M313 9.50012V33.2342" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M315 11.4998V32.9279" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M317 13V33" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M319 15.0001V31.0001" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M321 16.4998V28.4998" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M13 0.153198V27.4999" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M11 0.459351V25.9999" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M9 0.999878V23.9999" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M7 1.0719V21.9996" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M5 2.49988V19.9999" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M3 4.99988V17.9999" stroke="#C7C8D1" stroke-opacity="0.1"/>
                            <path d="M1 6.49963V16.4996" stroke="#C7C8D1" stroke-opacity="0.1"/>
                        </svg>
                    </div>
                </div>

                <div class="services-block">
                    <div class="header-block">
                        <div class="barrier">
                            <svg width="168" height="12" viewBox="0 0 168 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M155 1H150L161 11H166L155 1Z" fill="#CACACA" stroke="#CACACA"/>
                                <path d="M150 1H1.43051e-06" stroke="#CACACA"/>
                            </svg>
                        </div>
                        <div class="label">
                            {{ $t('mainPage.servicesHeader') }}
                        </div>
                        <div class="barrier">
                            <svg width="168" height="12" viewBox="0 0 168 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13 11H18L7 1H2L13 11Z" fill="#CACACA" stroke="#CACACA"/>
                                <path d="M18 11H168" stroke="#CACACA"/>
                            </svg>
                        </div>
                    </div>

                    <TariffSlider :cards="allTariffs" :key="chartKey" />
                </div>
            </div>

            <div class="adaptation-block__column">
                <div class="finance-block">
                    <div class="header-block">
                        <div class="barrier">
                            <svg width="100%" height="200%" viewBox="0 0 132 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M119 1H114L125 11H130L119 1Z" fill="#CACACA" stroke="#CACACA"/>
                                <path d="M114 1H0" stroke="#CACACA"/>
                            </svg>
                        </div>
                        <div class="label">
                            {{ $t('mainPage.financeHeader') }}
                        </div>
                        <div class="barrier">
                            <svg width="100%" height="200%" viewBox="0 0 132 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13 11H18L7 1H2L13 11Z" fill="#CACACA" stroke="#CACACA"/>
                                <path d="M18 11H132" stroke="#CACACA"/>
                            </svg>
                        </div>
                    </div>

                    <div class="bar-chart-container">
                        <div class="label">
                            <div>{{ $t('mainPage.outlays') }} {{ currentYear }}</div>
                        </div>
                        <BarChart :data="paymentChartData" :key="chartKey"/>
                    </div>

                    <div class="finance-block__buttons">
                        <uzhnet-button-secondary @click="$router.push('/finance')" :label="$t('mainPage.myPaymentsButton')" />
                        <uzhnet-button @click="$router.push('/payment-type')" :label="$t('mainPage.payButton')" />
                    </div>

                </div>
            </div>
        </div>

        <div class="menu-container__cover">
            <div class="left-top-corner">
                <svg width="5" height="5" viewBox="0 0 5 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <line x1="0.273566" y1="4.38867" x2="0.273566" y2="0.000100625" stroke="#CACACA" stroke-width="1"/>
                    <line x1="0.547852" y1="0.274542" x2="4.38785" y2="0.274542" stroke="#CACACA" stroke-width="1"/>
                </svg>
            </div>
            <div class="left-bottom-corner">
                <svg width="5" height="5" viewBox="0 0 5 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <line x1="4.38867" y1="4.11413" x2="0.000100637" y2="4.11413" stroke="#CACACA" stroke-width="1"/>
                    <line x1="0.274542" y1="3.83984" x2="0.274542" y2="-0.000156152" stroke="#CACACA" stroke-width="1"/>
                </svg>
            </div>
            <div class="right-top-corner">
                <svg width="5" height="5" viewBox="0 0 5 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <line y1="0.725714" x2="4.38857" y2="0.725714" stroke="#CACACA" stroke-width="1"/>
                    <path d="M4.11401 1L4.11401 4.84" stroke="#CACACA" stroke-width="1"/>
                </svg>
            </div>
            <div class="right-bottom-corner">
                <svg width="5" height="5" viewBox="0 0 5 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <line x1="4.11413" y1="1.19895e-08" x2="4.11413" y2="4.38857" stroke="#CACACA" stroke-width="1"/>
                    <line x1="3.83984" y1="4.11413" x2="-0.000156188" y2="4.11413" stroke="#CACACA" stroke-width="1"/>
                </svg>
            </div>

            <div class="menu-container">
                <div @click="$router.push('/profiles')" class="menu-container__button">
                    <img src="@/assets/icons/menu/profiles-icon.svg" alt="">
                </div>
                <div @click="$router.push('/contacts')" class="menu-container__button">
                    <img src="@/assets/icons/menu/contacts-icon.svg" alt="">
                </div>
                <div @click="$router.push('/bot')" class="menu-container__button">
                    <img src="@/assets/icons/menu/bot-icon.svg" alt="">
                </div>
                <div @click="$router.push('/notifications')" class="menu-container__button">
                    <img src="@/assets/icons/menu/bell-icon.svg" alt="">
                </div>
                <div @click="$router.push('/settings')" class="menu-container__button">
                    <img src="@/assets/icons/menu/settings-icon.svg" alt="">
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import '@/assets/scss/main-page.scss';

import BarChart from '@/components/BarChart.vue';
import TariffSlider from '@/components/TariffSlider.vue';

import MyHomeButton from '@/components/MyHomeButton.vue';

import { getDateStringByTimestamp, getMounthNameByNumber } from '@/services/utils';

import { ref, onMounted } from 'vue'
import { useMainStore } from '@/store/mainStore'

import { useI18n } from 'vue-i18n';

function transliterate(text) {
    const ukToEnMap = {
        'А': 'A', 'Б': 'B', 'В': 'V', 'Г': 'H', 'Ґ': 'G', 'Д': 'D',
        'Е': 'E', 'Є': 'Ye', 'Ж': 'Zh', 'З': 'Z', 'И': 'Y', 'І': 'I',
        'Ї': 'Yi', 'Й': 'Y', 'К': 'K', 'Л': 'L', 'М': 'M', 'Н': 'N',
        'О': 'O', 'П': 'P', 'Р': 'R', 'С': 'S', 'Т': 'T', 'У': 'U',
        'Ф': 'F', 'Х': 'Kh', 'Ц': 'Ts', 'Ч': 'Ch', 'Ш': 'Sh', 'Щ': 'Shch',
        'Ь': '', 'Ю': 'Yu', 'Я': 'Ya',
        'а': 'a', 'б': 'b', 'в': 'v', 'г': 'h', 'ґ': 'g', 'д': 'd',
        'е': 'e', 'є': 'ie', 'ж': 'zh', 'з': 'z', 'и': 'y', 'і': 'i',
        'ї': 'i', 'й': 'i', 'к': 'k', 'л': 'l', 'м': 'm', 'н': 'n',
        'о': 'o', 'п': 'p', 'р': 'r', 'с': 's', 'т': 't', 'у': 'u',
        'ф': 'f', 'х': 'kh', 'ц': 'ts', 'ч': 'ch', 'ш': 'sh', 'щ': 'shch',
        'ь': '\'', 'ю': 'iu', 'я': 'ia'
    };

    if (text) {
        return text.split('').map(char => ukToEnMap[char] || char).join('');
    } else {
        return text
    }
}

export default {
    name: 'MainView',

    setup(props, { emit }) {
        const store = useMainStore()

        const chartKey = ref(0)

        const allTariffs = ref([])

        const { t, locale } = useI18n();

        const alertLineFlag = ref(false)

        const paymentsByMonth = ref({
            'січень': { month: 'січень', sum: 0 },
            'лютий': { month: 'лютий', sum: 0 },
            'березень': { month: 'березень', sum: 0 },
            'квітень': { month: 'квітень', sum: 0 },
            'травень': { month: 'травень', sum: 0 },
            'червень': { month: 'червень', sum: 0 },
            'липень': { month: 'липень', sum: 0 },
            'серпень': { month: 'серпень', sum: 0 },
            'вересень': { month: 'вересень', sum: 0 },
            'жовтень': { month: 'жовтень', sum: 0 },
            'листопад': { month: 'листопад', sum: 0 },
            'грудень': { month: 'грудень', sum: 0 }
        })
        const paymentChartData = ref([])

        const currentYear = new Date().getFullYear()

        onMounted(() => {
            emit('startLoading')
            const allPayments = store.payments

            locale.value = localStorage.getItem('locale') || 'ua';

            if (store.payments) {
                allPayments.forEach(payment => {
                    let timestamp = +payment.date_pay
                    if (timestamp.toString().length === 10) {
                        timestamp *= 1000;
                    }
                    const date = new Date(timestamp)
                    const month = getMounthNameByNumber(date.getMonth())

                    if (date.getFullYear() !== currentYear) {
                        return
                    }

                    paymentsByMonth.value[month].sum += +payment.summa
                })

                paymentChartData.value = []
                Object.keys(paymentsByMonth.value).forEach(key => {
                    paymentChartData.value.push(paymentsByMonth.value[key].sum)
                })
            }

            if (store.internet_tariff) {
                allTariffs.value.push({
                    header: 'internet',
                    type: locale.value == 'en' ? transliterate(store.internet_tariff.name) : store.internet_tariff.name,
                    speed: store.internet_tariff.id_down,
                    unit: t('tariffSlider.speedValue'),
                    cost: store.balance,
                    activeUntil: getDateStringByTimestamp(store.payed_period),
                })
            }

            if (store.tv_tariff) {
                allTariffs.value.push({
                    header: 'tv',
                    type: locale.value == 'en' ? transliterate(store.tv_tariff.name) : store.tv_tariff.name,
                    speed: store.tv_tariff.channels,
                    unit: t('tariffSlider.channels'),
                    cost: store.balance,
                    activeUntil: getDateStringByTimestamp(store.tv_payed_period),
                })
            }

            if (store.payed_period && store.payed_period <= Date.now() / 1000) {
                alertLineFlag.value = true
            }

            chartKey.value += 1
            emit('stopLoading')
        })

        return {
            store,
            paymentChartData,
            chartKey,
            allTariffs,
            currentYear,
            locale,
            alertLineFlag,
            transliterate: transliterate,
            getDateStringByTimestamp: getDateStringByTimestamp
        }
    },

    components: {
        MyHomeButton,
        BarChart,
        TariffSlider,
    }
}
</script>
<style lang="scss">

    .barrier {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        max-width: 200px;
    }

    .label {
        font-size: 13px;
    }

    @media screen and (max-width: 305px) {
        .label {
            font-size: 10px;
        }

    }

    .christmas-gift {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 0;
        width: 140px;
        z-index: 100;
        cursor: pointer;
        transition: transform 0.3s ease;
    }

    .christmas-gift > img {
        width: 100%;
    }
</style>
